import styled from 'styled-components';
import DefaultTab from 'components/Tab';
import DefaultBrandSelect from 'components/Form/BrandSelect';
import StickyHeader from 'components/StickyHeader';
import DefaultSimpleLoader from 'components/Loaders/SimpleLoader';
import addAlpha from 'utils/addAlpha';

export const Container = styled.div`
  margin-bottom: 5rem;
`;

export const Header = styled(StickyHeader)``;

export const Tabs = styled.nav`
  display: flex;
`;

export const Tab = styled(DefaultTab)`
  :not(:last-child) {
    margin-right: 1rem;
  }
`;

export const SearchInputContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const BrandSelect = styled(DefaultBrandSelect)`
  margin-right: 4.5rem;
`;

export const Loader = styled(DefaultSimpleLoader)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  min-height: 100%;
  z-index: 10;
`;
